import { Colors, Text } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks/utils/useAmelioTranslations';

interface UnsentReplyProps {
    text: string;
    dataTestId?: string;
}

/**
 * A reply refused because replies were turned off while it was being written: its field is gone with
 * them, so the text stays on screen as it was typed, where it can still be copied.
 */
export const UnsentReply = ({ text, dataTestId = 'unsent-reply' }: UnsentReplyProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div
            className={'flex flex-col gap-1'}
            data-testid={dataTestId}
        >
            <Text
                size={'small'}
                weight={'medium'}
                color={Colors.BASE_600}
            >
                {t('reviewAnswer.commentThread.unsentReply')}
            </Text>

            <Text
                size={'small'}
                color={Colors.BASE}
                className={'break-words whitespace-pre-wrap'}
            >
                {text}
            </Text>
        </div>
    );
};
